// actions/employee-onboarding/groups.js

import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

export function groupsHasErrored(bool) {
  return {
    type: 'ONBOARDING_GROUPS_HAS_ERRORED',
    hasErrored: bool
  };
}

export function groupsIsLoading(bool) {
  return {
    type: 'ONBOARDING_GROUPS_IS_LOADING',
    isLoading: bool
  };
}

export function groupsFetchDataSuccess(data) {
  return {
    type: 'ONBOARDING_GROUPS_FETCH_DATA_SUCCESS',
    data
  };
}

export function groupsFetchData(host, params) {
  return (dispatch) => {
    dispatch(groupsIsLoading(true));
    dispatch(groupsHasErrored(false));
    fetch(host + 'admin/groups', {
      method: 'post',
      body: JSON.stringify(params),
      headers: attachAuth()
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            result.make_like_groups.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)); 
            dispatch(groupsFetchDataSuccess(result));
            dispatch(groupsHasErrored(false));
            dispatch(groupsIsLoading(false));
            PubSub.publish('employee.add.groups', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(groupsHasErrored(true));
            dispatch(groupsIsLoading(false));
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(groupsHasErrored(true));
      dispatch(groupsIsLoading(false));
    });
  };
}